<template>
  <v-card flat>
    <div style="height:550px; background-image: linear-gradient(#26A69A, #80CBC4); z-index:1000; padding: 15px 15px 60px 15px;" class="ma-0">
      <v-card-title class="pa-0 ma-0">
        <h2 class="ml-1 mb-1 white--text">Envios Mensais Global</h2>
        <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="200" offset-x>
          <template v-slot:activator="{ on }">
            <v-btn fab dark small icon v-on="on">
                <v-icon >alarm</v-icon>
            </v-btn>
          </template>
          <v-card class="pa-3">
            <v-text-field box label="Valor do temporizador" v-model="novoIntervalo"></v-text-field>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn flat @click="menu = false">Cancelar</v-btn>
              <v-btn color="teal" flat @click="intervalo(), menu = false">Alterar</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-card-title>
      <v-layout v-if="loadGraficos" align-center justify-center row fill-height>
        <v-progress-circular class="text-xs-center" :size="70" :width="7" color="#26A69A" indeterminate></v-progress-circular>
      </v-layout>
      <div v-if="!loadGraficos && envios.length > 0" style="height: 450px;">
        <vue-chart
          :data="{
                        labels: meses(mesesEnvio),
                        datasets: [
                            {
                                label: envios[1] && envios[1].label,
                                backgroundColor: envios[0] && envios[0].backgroundColor,
                                data: envios[1] && envios[1].data
                            },
                            {
                                label: envios[0] &&  envios[0].label,
                                backgroundColor: envios[1] && envios[1].backgroundColor,
                                data: envios[0] && envios[0].data
                            }
                        ]
                    }"
          type="line"
          :options="options"
        />
      </div>
    </div>
    <v-card class="pa-1 ml-3 mr-3 mb-5 elevation-10" style="margin-top: -35px;">
      <v-card-title>
        <h2>Quantidade de Envios por Operadora</h2>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md text-xs-center>
          <v-layout row>
            <v-flex :xs6="operadoras && operadoras.length > 1" v-for="(op,i) in operadoras" :key="i">
              <v-layout v-if="loadOperadoras" align-center justify-center row fill-height>
                <v-progress-circular class="text-xs-center" :size="70" :width="7" color="#26A69A" indeterminate></v-progress-circular>
              </v-layout>
              <div v-if="!loadOperadoras && envios.length > 0">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-avatar :tile="false" :size="85" color="teal lighten-4" v-on="on">
                      <span class="display-3">{{ ( op.operadora && op.operadora.substr(0,1) ) || '-' }}</span>
                    </v-avatar>
                  </template>
                  <span class="headline">{{op.operadora || 'Outras'}}</span>
                </v-tooltip>
                <h3 class="display-2">{{op.sucessos}}</h3>
              </div>
            </v-flex>
            <!--<v-divider
                        v-if="operadoras && operadoras.length > 1"
                        vertical
            ></v-divider>-->
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
<!--     <v-card class="pa-1 ml-3 mr-3 mb-5 elevation-10">
      <v-card-title>
        <v-flex xs12>
            <h2>Envios Mensais por empresa</h2>
        </v-flex>
        <v-flex xs2 ml-3>
          <v-select
            color="teal"
            label="Selecione a Empresa"
            :items="usuariosInternos"
            item-text="firstname"
            item-value="_id"
            v-model="sumario.empresa"
          ></v-select>
        </v-flex>
        <v-flex xs2 ml-3>
          <v-select
            color="teal"
            label="Selecione o mês"
            :items="mesesSumario"
            item-text="text"
            item-value="value"
            v-model="sumario.mes"
          ></v-select>
        </v-flex>
        <v-flex xs3 ml-3>
            <v-btn round color="fundo" @click="buscaSumario">Buscar</v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text>
        <div
          v-if="enviosEmpresa && enviosEmpresa.hasOwnProperty('sucessos') && enviosEmpresa.hasOwnProperty('erros')"
        >
          <h2>Totais</h2>
          <h3>
            Sucessos:
            <span class="primary--text font-weight-bold">{{enviosEmpresa.sucessos}}</span> Erros:
            <span class="red--text font-weight-bold">{{enviosEmpresa.erros}}</span>
          </h3>
          <div style="height: 300px;">
            <vue-chart
              :data="{
                            datasets: [
                                {
                                    fill: true,
                                    backgroundColor: [
                                        '#2196F3',
                                        '#F44336'
                                    ],
                                    data: [enviosEmpresa.sucessos, enviosEmpresa.erros],
                                }
                            ],
                            labels: ['Sucessos', 'Erros']
                        }"
              type="pie"
              :options="optionsEmpresa"
            />
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="pa-1 ml-3 mr-3 mb-5 elevation-10">
      <v-card-title>
          <v-flex xs12>
            <h2>Envios Diários por empresa</h2>
          </v-flex>
        <v-flex xs3 ml-3>
          <v-select
            color="teal"
            label="Selecione a Empresa"
            :items="usuariosInternos"
            item-text="firstname"
            item-value="_id"
            v-model="empresa_id"
          ></v-select>
        </v-flex>
        <v-btn round color="fundo" @click="buscaEnviosDia">Buscar</v-btn>
      </v-card-title>
      <v-card-text>
        <div v-if="enviosEmpresaDia && enviosEmpresaDia.enviadasDia && enviosEmpresaDia.errosDia">
          <h2>Totais</h2>
          <h3>
            Sucessos:
            <span class="primary--text font-weight-bold">{{enviosEmpresaDia.enviadasDia}}</span> Erros:
            <span class="red--text font-weight-bold">{{enviosEmpresaDia.errosDia}}</span>
          </h3>
          <div style="height: 300px;">
            <vue-chart
              :data="{
                            datasets: [
                                {
                                    fill: true,
                                    backgroundColor: [
                                        '#2196F3',
                                        '#F44336'
                                    ],
                                    data: [enviosEmpresaDia.enviadasDia, enviosEmpresaDia.errosDia],
                                }
                            ],
                            labels: ['Sucessos', 'Erros']
                        }"
              type="pie"
              :options="optionsEmpresa"
            />
          </div>
        </div>
      </v-card-text>
    </v-card> -->
     <v-card class="pa-1 ml-3 mr-3 mb-5 elevation-10">
            <v-flex xs12 class="white">
                <v-tabs next-icon="mdi-arrow-right-bold-box-outline" icons-text prev-icon="mdi-arrow-left-bold-box-outline" show-arrows="show-arrows">
                <v-tabs-slider color="blue-grey darken-3"></v-tabs-slider>
                <v-tab ripple ><v-icon class="v-icon icon-home material-icons mr-2">insert_chart </v-icon> Pesquisa por período</v-tab>

                <v-tab ripple ><v-icon class="v-icon icon-home material-icons mr-2">send </v-icon> Relatório Geral</v-tab>
                <v-tab-item>
                    <v-card-title>
                        <v-flex xs3 ml-3>
                            <v-autocomplete v-model="user_id" :loading="loading" :items="empresaNomeEmail" item-text="nome" return-object  :search-input.sync="search" cache-items color="fundo" flat
                                label="Nome/E-mail" ></v-autocomplete>
                        </v-flex>
                        <v-flex xs3 ml-3>
                            <v-menu v-model="menuPicker" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="date1" label="Data Inicial" color="fundo" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="date1" @input="menuPicker = false" color="fundo"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs3 ml-3>
                            <v-menu v-model="menuPicker2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="date2" label="Data Final" color="fundo" readonly v-on="on"></v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="date2" @input="menuPicker2 = false" color="fundo"></v-date-picker>
                            </v-menu>
                        </v-flex>
                        <v-btn round color="fundo" @click="buscaEnviosPeriodo">Buscar</v-btn>
                    </v-card-title>
                    <v-card-text>
                        <div v-if="envioPeriodo && envioPeriodo.sucessos && envioPeriodo.erros">
                        <h2>Totais</h2>
                        <h3>
                            Sucessos:
                            <span class="primary--text font-weight-bold">{{envioPeriodo.sucessos}}</span> Erros:
                            <span class="red--text font-weight-bold">{{envioPeriodo.erros}}</span>
                        </h3>
                        <div style="height: 300px;">
                            <vue-chart
                            :data="{
                                            datasets: [
                                                {
                                                    fill: true,
                                                    backgroundColor: [
                                                        '#2196F3',
                                                        '#F44336'
                                                    ],
                                                    data: [envioPeriodo.sucessos, envioPeriodo.erros],
                                                }
                                            ],
                                            labels: ['Sucessos', 'Erros']
                                        }"
                            type="pie"
                            :options="optionsEmpresa"
                            />
                        </div>
                        </div>
                    </v-card-text>
                </v-tab-item>
                <v-tab-item>
                    <v-card-title>
                        <v-flex xs6 ml-3>
                            <v-select color="teal" :items="mesesSumario" label="Selecione o mês" item-text="text" item-value="value" v-model="mes"></v-select>
                        </v-flex>
                        <v-btn round color="fundo" @click="buscaRelatorioGeral">Buscar</v-btn>
                    </v-card-title>
                    <v-card-text>
                    <v-flex xs12>
                        <!-- <v-flex xs12 sm6>
                             <v-list two-line>
                                <template v-for="item in itemsRelatorioGeral">
                                    <v-list-tile :key="item">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.empresa.firstname }}</v-list-tile-title>
                                            <v-list-tile-sub-title class="primary--text font-weight-bold">Sucessos: {{item.sucessos }}</v-list-tile-sub-title>
                                            <v-list-tile-sub-title class="red--text font-weight-bold">Erros: {{ item.erros }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-flex> -->
                        <v-flex xs12>
                             <h2>Totais</h2>
                        <h3>
                            Sucessos:
                            <span class="primary--text font-weight-bold">{{itemGraficoSucessos}}</span> Erros:
                            <span class="red--text font-weight-bold">{{itemGraficoErros}}</span>
                        </h3>
                        <div style="height: 300px;">
                            <vue-chart
                                :data="{
                                            datasets: [
                                                {
                                                    fill: true,
                                                    backgroundColor: [
                                                        '#2196F3',
                                                        '#F44336'
                                                    ],
                                                    data: [ itemGraficoSucessos, itemGraficoErros ],
                                                }
                                            ],
                                            labels: ['Sucessos', 'Erros']
                                        }"
                            type="pie"
                            :options="optionsEmpresa"
                            />
                        </div>
                        </v-flex>
                    </v-flex>
                    </v-card-text>
                     <v-card flat class="mb-3 pb-3">
                        <v-flex xs12 >
                            <!-- {{this.itemsRelatorioGeral}} -->
                            <v-data-table :headers="headers" :items="itemsRelatorioGeral"  no-data-text="Sem resultados" class="elevation-1" hide-actions>
                                <template v-slot:items="props">
                                    <td >{{ props.item.empresa.firstname }}</td>
                                    <td >{{ props.item.empresa.email }}</td>
                                    <td >{{ props.item.empresa.operator }}</td>
                                    <td >{{ props.item.sucessos }}</td>
                                    <td >{{ props.item.erros }}</td>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-card>
                </v-tab-item>

            </v-tabs>
        </v-flex>
    </v-card>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
        itemGraficoSucessos:'',
        itemGraficoErros:'',
        itemsRelatorioGeral:[],
        search: null,
        loading:false,
        date1           : new Date().toISOString().substr(0, 10),
        date2           : new Date().toISOString().substr(0, 10),
        menuPicker      : false,
        menuPicker2     : false,
        menu: false,
        novoIntervalo: 0,
        selecionaversao: false,
        usuariosInternos: [],
        empresaNomeEmail: [],
        empresa_id: '',
        user_id:'',
        user_id_relatorio:'',
        loadGraficos: false,
        loadOperadoras: false,
        interval: 0,
        intervaloSelecionado: 10000,
        dados: null,
        sumario: {
            empresa: "",
            mes:""
        },
        mes: '',
         headers: [
          {text: 'Nome', value: 'firstname', align: 'center', sortable: false },
          { text: 'Email', value: 'email', align: 'center', sortable: false  },
          { text: 'Operadora', value: 'operator', align: 'center', sortable: false  },
          { text: 'Sucessos', value: 'sucessos', align: 'center', sortable: false  },
          { text: 'Erros', value: 'erros', align: 'center', sortable: false  },
        ],
        horas: [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
        select:'',
        mesesSumario: [
            {text: 'Janeiro', value: 1},
            {text: 'Fevereiro', value: 2},
            {text: 'Março', value: 3},
            {text: 'Abril', value: 4},
            {text: 'Maio', value: 5},
            {text: 'Junho', value: 6},
            {text: 'Julho', value: 7},
            {text: 'Agosto', value: 8},
            {text: 'Setembro', value: 9},
            {text: 'Outubro', value: 10},
            {text: 'Novembro', value: 11},
            {text: 'Dezembro', value: 12},
        ],
        envios: [],
        mesesEnvio: [],
        operadoras: [],
        enviosEmpresa: {},
        enviosEmpresaDia: {},
        envioPeriodo:{},
        versao: "",
        dialog: false,
        hora: "15h12",
        optionsEmpresa: {
            maintainAspectRatio: false,
            responsive: true
        },
        options: {
            legend: {
            display: true,
            labels: {
                defaultFontColor: "#fff",
                fontColor: "#fff",
                fontSize: 12
            }
            },
            tooltips: {
            callbacks: {
                label: function(tooltipItem) {
                return tooltipItem.yLabel;
                }
            }
            },
            scales: {
            yAxes: [
                {
                stacked: true,
                ticks: {
                    fontColor: "white",

                    beginAtZero: true
                },
                gridLines: {
                    display: false,
                    color: "#FFFFFF"
                }
                }
            ],
            xAxes: [
                {
                stacked: true,
                ticks: {
                    fontColor: "white",

                    beginAtZero: true
                },
                gridLines: {
                    display: false,
                    color: "#FFFFFF"
                }
                }
            ]
            },
            maintainAspectRatio: false,
            responsive: true
        },
        optionsRadar: {
            legend: {
            display: true,
            labels: {
                defaultFontColor: "#fff",
                fontColor: "#fff",
                fontSize: 12
                }
            },
            elements: {
            line: {
                tension: 0 // disables bezier curves
                }
            },
            tooltips: {
            callbacks: {
                label: function(tooltipItem) {
                    return tooltipItem.yLabel;
                    }
                }
            },
            scales: {
            yAxes: [
                {
                    stacked: false
                }
                ]
            },
            maintainAspectRatio: false,
            responsive: true
        }
        };
  },
  computed: {
    ...mapGetters(["getAppVersion", "getAppID", "getAtualVersion"])
  },
  methods: {
    ...mapActions([
      "loadApplication",
      "enviosMes",
      "sumarios",
      "loadUsuariosAstandes",
      "enviosOperadora",
      "enviosEmpresaPeriodo",
      "getRelatorioGeral"
    ]),
    meses(dados) {
      return dados.map(_ => {
        if (_ == 1) return "Janeiro"
        if (_ == 2) return "Fevereiro"
        if (_ == 3) return "Março"
        if (_ == 4) return "Abril"
        if (_ == 5) return "Maio"
        if (_ == 6) return "Junho"
        if (_ == 7) return "Julho"
        if (_ == 8) return "Agosto"
        if (_ == 9) return "Setembro"
        if (_ == 10) return "Outubro"
        if (_ == 11) return "Novembro"
        if (_ == 12) return "Dezembro"
      })
    },
    intervalo()
    {
        clearInterval(this.interval)
        this.intervaloSelecionado = this.novoIntervalo + '000'
        this.intervaloSelecionado = +this.intervaloSelecionado
        if(this.novoIntervalo != 0) this.interval = setInterval(() => this.buscaMes(),this.intervaloSelecionado)
    },
    async buscaMes() {
      let result = await this.enviosMes()
      let resOp = await this.enviosOperadora()

      if (result) {
          //console.log(result)
        this.envios = result.resultado.dados
        this.mesesEnvio = result.resultado.meses
        //console.log(this.envios)
        this.loadGraficos = false
      }

      if (resOp) {
        this.loadOperadoras = false
        this.operadoras = resOp
      }
    },
    textoVersao(versao) {
      this.selecionaversao = true
      this.versao = this.getAppVersion.find(
        v => v.descricao == new String(versao)
      ).text;
      return this.versao
    },
    async buscaSumario() {
      this.enviosEmpresa = await this.sumarios(this.sumario)
    },
    buscaEnviosDia() {
        this.enviosEmpresaDia = this.usuariosInternos.find(_ => _._id == this.empresa_id).sumaryV2
        //console.log(this.enviosEmpresaDia)
    },
    async buscaEnviosPeriodo(){
         if(this.date1 === this.date2){
            const { sumaryV2 } = this.usuariosInternos.find(_ => _._id == this.user_id._id)
            sumaryV2 && (this.envioPeriodo = {sucessos: sumaryV2.enviadasDia, erros: sumaryV2.errosDia})
            return
        }
        const { status, data } = await this.enviosEmpresaPeriodo({
                user_id : this.user_id._id,
                dt_ini  : this.date1,
                dt_fim  : this.date2
        })
            if(status) this.envioPeriodo = data

            //console.log(this.envioPeriodo)

    },
    async loadUsuarios() {
      this.usuariosInternos = await this.loadUsuariosAstandes()
      this.empresaNomeEmail = [ ...this.usuariosInternos.map( _=> ({ _id: _._id, nome: _.email }) ), ...this.usuariosInternos.map( _=> ({ _id: _._id, nome: _.firstname }) )]
      //console.log(this.empresaNomeEmail)

    },
    async buscaRelatorioGeral(){
        let retorno = []

        if(!this.mes) {
            retorno = await this.getRelatorioGeral(new Date().toISOString().substr(0, 10))
            this.mes = new Date().getMonth() + 1
        } else {
            let dateTemp = new Date()
            dateTemp.setMonth(this.mes - 1)
            retorno = await this.getRelatorioGeral(dateTemp.toISOString().substr(0, 10))
        }

        this.itemsRelatorioGeral = retorno.data || []
        if(this.itemsRelatorioGeral.length){
            this.itemGraficoSucessos = this.itemsRelatorioGeral.reduce((acc, value) => (acc += value.sucessos), 0 )
            this.itemGraficoErros = this.itemsRelatorioGeral.reduce((acc, value) => (acc += value.erros), 0 )
        }
        console.log(this.itemsRelatorioGeral)
    },

  },

  async mounted() {
    this.buscaRelatorioGeral()
    //console.log(this.buscaRelatorioGeral)
    this.loadApplication(this.getAppID)
    this.loadUsuarios()
    this.loadOperadoras = true
    this.loadGraficos = true

    this.buscaMes()
    if(this.novoIntervalo == 0)
        this.interval = setInterval(() => this.buscaMes(),this.intervaloSelecionado)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  destroyed() {
    clearInterval(this.interval)
  }
};
</script>




// WEBPACK FOOTER //
// src/components/root/Sumarios.vue